import { NgClass, NgForOf } from '@angular/common';
import { Component, ElementRef, inject, Input } from '@angular/core';
import { MatDialogActions } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonComponent,
  IButtonConfig,
} from 'shared/components/atoms/button/button.component';

@Component({
    selector: 'app-popup-footer',
    templateUrl: './popup-footer.component.html',
    imports: [
        MatDialogActions,
        ButtonComponent,
        NgForOf,
        TranslateModule,
        NgClass,
    ],
    styleUrl: 'popup-footer.component.scss'
})
export class PopupFooterComponent {
  public elementRef = inject(ElementRef);
  @Input() public buttons: IButtonConfig[] = [];
}
